// Menu translation file - Fixed personal settings menu display issue
import defaultProcessMenu from './menu.default';
import kdProcessMenu from './menu.kd';

const customerOverrides: Record<string, Record<string, string>> = {
  kd: kdProcessMenu,
};

const CUSTOMER: string = process.env.CUSTOMER || 'default';

export default {
  'menu.welcome': 'Welcome',
  'menu.overview': 'Project Overview',
  'menu.project-settings': 'Project Settings',
  'menu.project-info': 'Project Information',
  'menu.process-config': 'Process Configuration',
  'menu.team-management': 'Team Management',
  'menu.dev-repository': 'Development Repository',
  'menu.recycle-bin': 'Recycle Bin',
  'menu.work-products': 'Work Products',
  'menu.review-tasks': 'Review Tasks',
  'menu.system-overview': 'System Overview',
  'menu.user-list': 'User List',
  'menu.project-list': 'Project List',
  'menu.system-settings': 'System Settings',
  'menu.personal-settings': 'Personal Settings',
  'menu.account-info': 'Account Information',
  'menu.notifications': 'Notifications',
  'menu.process-docs-preview': 'Process Documents Preview',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',

  // ASPICE专员界面菜单
  'menu.aspice.overview': 'System Overview',
  'menu.aspice.projects': 'Project List',
  'menu.aspice.templates': 'Template List',
  'menu.aspice.roles': 'Role List',
  'menu.aspice.processdocs': 'Process Documents',
  'menu.aspice.backToNormal': 'Return to development page',

  // ASPICE process names - work products menu (overridden by customer config via CUSTOMER env var)
  ...defaultProcessMenu,
  ...(customerOverrides[CUSTOMER] || {}),
};
